import { inject, Injectable } from '@angular/core';
import { ApiDataAccess, ResponseResult } from '@softline/core';
import {
  SOFTLINE_API_BEWEKOMMSCAN,
  SOFTLINE_API_KOPFKOMM_BEWEKOMMSCAN,
} from '../kommissionierung.api';
import { Bewekommscan } from '../types/bewekommscan';

@Injectable({ providedIn: 'root' })
export class PickingScanRepository {
  readonly #dataAccess = inject(ApiDataAccess);

  async loadAll(idkopfkomm: number): Promise<Bewekommscan[]> {
    return (
      (
        await this.#dataAccess.get<ResponseResult<Bewekommscan[]>>({
          path: SOFTLINE_API_KOPFKOMM_BEWEKOMMSCAN,
          pathParams: { idkopfkomm },
        })
      )?.result ?? []
    );
  }

  async reduce(id: number, menge: number): Promise<void> {
    await this.#dataAccess.patch<{ menge: number }, void>(
      { path: SOFTLINE_API_BEWEKOMMSCAN, pathParams: { id } },
      { menge }
    );
  }

  async remove(id: number): Promise<void> {
    await this.#dataAccess.delete<void>({
      path: SOFTLINE_API_BEWEKOMMSCAN,
      pathParams: { id },
    });
  }
}
